import React, { useState } from 'react';
import {
  AnimatedProgress,
  DealContainer,
  DealDetails,
  DealName,
  DealSection,
  LightningSectionNew,
  ProgressBarBackground,
} from './styled';
import { images } from '../../../Constants/ImageUrls';
import LightningTimer from './LightningTimer/LightningTimer';

const LighteningDealNew = (props) => {
  const { startDate, endDate, webDealPrice } = props;
  let currentDay = new Date().toISOString();
  const [progresBarStatus, setProgressBarStatus] = useState(
    getProgressBarStatus(),
  );

  function getDayFromMiliseconds(milisec) {
    return milisec / (1000 * 60 * 60 * 24);
  }

  function getProgressBarStatus() {
    const dealLength = getDayFromMiliseconds(
      new Date(endDate) - new Date(startDate),
    );
    const elapsedTime = getDayFromMiliseconds(
      new Date(currentDay) - new Date(startDate),
    );
    if (elapsedTime > 0 && elapsedTime < dealLength) {
      const calculatedPercentageFilled = (elapsedTime / dealLength) * 100;
      return calculatedPercentageFilled < 20 ? 20 : calculatedPercentageFilled;
    } else {
      return 100;
    }
  }

  return (
    <LightningSectionNew>
      <img src={images.lightningSectionBg} alt="" />
      <DealContainer>
        <DealDetails>Get it for {`₹${webDealPrice}`}</DealDetails>
        <ProgressBarBackground new={true}>
          <AnimatedProgress
            id="progressBar"
            progresBarStatus={`${progresBarStatus}%`}
          ></AnimatedProgress>
        </ProgressBarBackground>
        <DealSection>
          <DealName>Lightning Deal⚡</DealName>
          <LightningTimer endTime={endDate} />
        </DealSection>
      </DealContainer>
    </LightningSectionNew>
  );
};

export default LighteningDealNew;
